import { signal } from '@preact/signals-react';

export const backofficeLanguage = signal<string>("NL");
export const languages = signal<string[]>([]); // SupportedLanguages from api call: WhoAmI { nl, en }
